const images4 = [
  {
    imgURL:
      "https://m.media-amazon.com/images/I/71MQo8pHmBL._AC_SY200_.jpg",
    imgAlt: "img-1"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/51lP01--ejL._AC_SY200_.jpg",
    imgAlt: "img-2"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/51299uVd3YL._AC_SY200_.jpg",
    imgAlt: "img-2"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/810uTkxBmzL._AC_SY200_.jpg",
    imgAlt: "img-3"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/718f8oZHkSL._AC_SY200_.jpg",
    imgAlt: "img-4"
  },


];

export default images4;
